import React from 'react';
import Immutable from 'immutable';
import {
	styled,
	ParentBoundComponent,
	TabPane
} from 'ps-gui';

import { getPhrase } from '../../data/phrases';
import UserProfileModel from './userprofilemodel';
import {
	ModuleBodySection,
	ModuleHeader,
	ModuleHeaderBlock
} from '../../blocks/modulesections';
import Profile from './components/profiletab';
import PasswordChangeTab from './components/passwordchangetab';
import RolesTab from './components/roles';
import BankIdTab from './components/bankidtab';

export default class UserProfileModule extends ParentBoundComponent {
	constructor() {
		super();
		this.tabs = Immutable.fromJS([
			{
				id: 'profile',
				text: getPhrase('profile')
			},
			{
				id: 'roleList',
				text: getPhrase('roleList')
			},
			{
				id: 'passwordChange',
				text: getPhrase('passwordChange')
			},
			{
				id: 'bankIdentities',
				text: getPhrase('bankIdentities')
			}
		]);
		this.onTabSelected = this.onTabSelected.bind(this);
		this.setPassword = this.setPassword.bind(this);
		this.setPasswordChangeProperty = this.setPasswordChangeProperty.bind(this);
		this.toggleAltNamesExpanded = this.toggleAltNamesExpanded.bind(this);
		this.onDeleteBankIdentity = this.onDeleteBankIdentity.bind(this);
	}

	async onDeleteBankIdentity(id) {
		this.setModel(await this.getModel().deleteBankIdentity(id));
	}

	async componentDidMount() {
		if (!this.getData().get('initialized')) {
			this.setModel(await this.getModel().initialize());
		}
	}

	getModel() {
		return new UserProfileModel(this.getData());
	}

	setModel(model) {
		this.setData(model.getData());
	}

	async setPassword() {
		this.setModel(await this.getModel().setPassword());
	}

	onTabSelected(tabId) {
		this.setModel(this.getModel().setSelectedTabId(tabId));
	}

	toggleAltNamesExpanded(index) {
		this.setModel(this.getModel().toggleAltNamesExpanded(index));
	}

	setPasswordChangeProperty(name, value) {
		this.setModel(this.getModel().setPasswordChangeProperty(name, value));
	}

	renderTabContent(model) {
		// Using switch here, because that is exactly what tab menu does
		switch(model.getSelectedTabId()) {
		case 'roleList':
			return (
				<RolesTab
					parties={model.getParties()}
					toggleAltNamesExpanded={this.toggleAltNamesExpanded}
				/>
			);
		case 'passwordChange':
			return (
				<PasswordChangeTab
					data={model.getPasswordChangeData()}
					setPassword={this.setPassword}
					setPasswordChangeProperty={this.setPasswordChangeProperty}
				/>
			);
		case 'bankIdentities':
			return (
				<BankIdTab
					bankIdentities={model.getBankIdentities()}
					onDeleteBankIdentity={this.onDeleteBankIdentity}
				/>
			);
		default:
			return <Profile profile={model.getProfile()} />;
		}
	}

	render() {
		const model = this.getModel();
		return (
			<Wrapper>
				<ModuleHeaderBlock>
					<ModuleHeader>{getPhrase('UserProfile')}</ModuleHeader>
				</ModuleHeaderBlock>
				<ModuleBodySection>
					<TabPane
						tabs={this.tabs}
						selectedTabId={model.getSelectedTabId()}
						onTabSelected={this.onTabSelected}
						contentClassName="tabContent"
					>
						{this.renderTabContent(model)}
					</TabPane>
				</ModuleBodySection>
			</Wrapper>
		);
	}
}

const Wrapper = styled.div`
	.tabContent {
		padding: 16px;
	}
`;
